import { isNil } from 'lodash';
import { useEffect } from 'react';
export const destroyInteraction = (interactionRef) => {
    interactionRef.current?.destroy();
    interactionRef.current = null;
};
export const useInteraction = (Interaction, interactionRef, callback, eventName, nvlRef, interactionOptions) => {
    useEffect(() => {
        const container = nvlRef.current?.getContainer();
        // Make sure we are not mounting interaction handlers when there is NVL setup
        if (isNil(container)) {
            return;
        }
        if ((callback === true || typeof callback === 'function') && !isNil(nvlRef.current)) {
            if (isNil(interactionRef.current)) {
                interactionRef.current = new Interaction(nvlRef.current, interactionOptions);
            }
            if (typeof callback === 'function') {
                interactionRef.current.updateCallback(eventName, callback);
            }
            else if (!isNil(interactionRef.current.callbackMap[eventName])) {
                interactionRef.current.removeCallback(eventName);
            }
        }
        else if (callback === false) {
            destroyInteraction(interactionRef);
        }
    }, [Interaction, callback, eventName, interactionOptions, interactionRef, nvlRef]);
};
